import ExpandButton from './ExpandButton';
import { useToggleExpand } from './hooks';
import TextContentLink from './InternalLink';
import {
  InternalLinkModWrapper,
  InternalLinkModOverview,
  InternalModLinks,
  InternalLinkModTitle,
  InternalLinkModArea
} from './styles';

const InternalLinkMod = ({ linksData = {}, minLinks = 9 }) => {
  const [isExpanded, toggle] = useToggleExpand();

  const { links = [], title: sectionTitle = '' } = linksData;

  const isNotDivisibleByThree = links.length % 3 !== 0;
  const showViewMoreButton = links.length > 9;

  const outputMappedLink = ({ text, link }, index) => {
    return (
      <TextContentLink
        key={link}
        isVisible={index < minLinks || isExpanded}
        title={text}
        link={link}
      />
    );
  };

  const cvTag = sectionTitle.replace(/[ ,.]/g, '');

  return links.length ? (
    <InternalLinkModWrapper data-cv-test={`Cv.Search.Content${cvTag}.Wrapper`}>
      <InternalLinkModOverview>
        <InternalModLinks>
          <InternalLinkModTitle>{sectionTitle}</InternalLinkModTitle>
          <InternalLinkModArea isNotDivisibleByThree={isNotDivisibleByThree}>
            {links.slice(0, 9).map(outputMappedLink)}
            {isExpanded ? (
              <div style={{ display: 'contents' }}>
                {links.slice(9, links.length).map(outputMappedLink)}
              </div>
            ) : (
              <div style={{ height: '0px', visibility: 'hidden' }}>
                {links.slice(9, links.length).map(outputMappedLink)}
              </div>
            )}
          </InternalLinkModArea>
          {showViewMoreButton && (
            <ExpandButton toggleExpand={toggle} isExpanded={isExpanded} />
          )}
        </InternalModLinks>
      </InternalLinkModOverview>
    </InternalLinkModWrapper>
  ) : null;
};

export default InternalLinkMod;
